export default function validation(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('FUSION_TYPE_DIFF') !== -1) {
      messages.push({
        message: 'listeIntervention.fusion.error.typeDiff',
      });
    }
    if (message.indexOf('FUSION_AGENCE_DIFF') !== -1) {
      messages.push({
        message: 'listeIntervention.fusion.error.agenceDiff',
      });
    }
  });
}
